import React, { Component } from 'react'
import { getBranchesLatest } from '../../store/actions';
import moment from 'moment';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetCalendar from '../../classetComponents/classetCalender';
import Authentication from '../../session';
import { connect } from 'react-redux';
import withRouter from '../lib/withRouter';
import { BasicLazyParams } from '../../utile';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import * as XLSX from 'xlsx';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';


// Define date range options
const dateRangeOptions = [
    { value: 1, label: "Today" },
    { value: 2, label: "Yesterday" },
    { value: 3, label: "This Week" },
    { value: 4, label: "Last Week" },
    { value: 5, label: "This Month" },
    { value: 6, label: "Last 3 Months" },
    { value: 7, label: "Current Academic Year" },
    { value: 8, label: "Custom" }
];
class RefundReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dropdownsData: {},
            lazyParams: {
                ...BasicLazyParams,
                first: 0,
                rows: 5,  // Setting default to 5 records per page
                page: 0
            },
            feeRefundReport: [],
            filteredData: [],
            currentData: [],
            selectedDateRange: 7, // Default to Current Academic Year
            dateRangeType: 'custom',
            startDate: null,
            endDate: null,
            isLoading: false,
            totalRecords: 0,
            showCustomDateRange: false
        }
        this.service = new Service()
    }

    componentDidMount() {
        this.getFeeRefundReportInfo();
    }

    filterByDateRange = (data) => {
        const { selectedDateRange, startDate, endDate } = this.state;
        let filteredData = [...data];

        switch (selectedDateRange) {
            case 1: // Today
                filteredData = data.filter(item => {
                    const itemDate = moment(item.createdAt);
                    return itemDate.isSame(moment(), 'day');
                });
                break;
            case 2: // Yesterday
                filteredData = data.filter(item => {
                    const itemDate = moment(item.createdAt);
                    return itemDate.isSame(moment().subtract(1, 'days'), 'day');
                });
                break;
            case 3: // This Week
                filteredData = data.filter(item => {
                    const itemDate = moment(item.createdAt);
                    return itemDate.isSameOrAfter(moment().startOf('week')) &&
                        itemDate.isSameOrBefore(moment().endOf('week'));
                });
                break;
            case 4: // Last Week
                filteredData = data.filter(item => {
                    const itemDate = moment(item.createdAt);
                    const lastWeekStart = moment().subtract(1, 'weeks').startOf('week');
                    const lastWeekEnd = moment().subtract(1, 'weeks').endOf('week');
                    return itemDate.isSameOrAfter(lastWeekStart) && itemDate.isSameOrBefore(lastWeekEnd);
                });
                break;
            case 5: // This Month
                filteredData = data.filter(item => {
                    const itemDate = moment(item.createdAt);
                    return itemDate.isSame(moment(), 'month');
                });
                break;
            case 6: // Last 3 Months
                filteredData = data.filter(item => {
                    const itemDate = moment(item.createdAt);
                    return itemDate.isSameOrAfter(moment().subtract(3, 'months'));
                });
                break;
            case 7: // Current Academic Year
                const academicYear = localStorage.getItem('userAcademicYear');
                if (academicYear) {
                    filteredData = data.filter(item => {
                        // Filter by academic year if available in the data
                        return item.academicYear === academicYear;
                    });
                }
                break;
            case 8: // Custom Date Range
                console.log("Custom date range filtering with", { startDate, endDate });
                if (startDate && endDate) {
                    filteredData = data.filter(item => {
                        if (!item.createdAt) return false;
                        const itemDate = moment(item.createdAt);
                        const result = itemDate.isSameOrAfter(moment(startDate).startOf('day')) &&
                            itemDate.isSameOrBefore(moment(endDate).endOf('day'));
                        return result;
                    });
                    console.log(`Filtered to ${filteredData.length} items after applying date range`);
                } else if (startDate) {
                    filteredData = data.filter(item => {
                        if (!item.createdAt) return false;
                        const itemDate = moment(item.createdAt);
                        return itemDate.isSameOrAfter(moment(startDate).startOf('day'));
                    });
                } else if (endDate) {
                    filteredData = data.filter(item => {
                        if (!item.createdAt) return false;
                        const itemDate = moment(item.createdAt);
                        return itemDate.isSameOrBefore(moment(endDate).endOf('day'));
                    });
                }
                break;
            default:
                break;
        }

        return filteredData;
    }
    getFeeRefundReportInfo = async () => {
        let { lazyParams, globalSearch } = this.state;
        this.setState({
            isLoading: true,
        });

        // We're doing frontend pagination, so get all data at once without pagination params in API
        let url = `${baseUrlAdmin}/financeReports/feeRefundReport?search=${globalSearch || ''}`;
        let payload = {
            academicYear: localStorage.getItem('userAcademicYear'),
            boardIds: this.state.dropdownsData.boardIds,
            classIds: this.state.dropdownsData.classIds,
            branchIds: this.state.dropdownsData.branchIds,
            sectionIds: this.state.dropdownsData.sectionIds,
            dateRangeType: this.state.dateRangeType,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        }

        this.service.post(url, payload, true).then(data => {
            if (data.status && data?.res?.status) {
                const allData = data?.res?.data || [];
                console.log(`Received ${allData.length} records from API`);

                this.setState({
                    feeRefundReport: allData,
                    isLoading: false
                }, () => {
                    // Apply filters and pagination after data is loaded
                    this.applyAllFilters();
                });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch refund report data', life: 3000 });
            }
        }).catch(error => {
            console.error('Error fetching refund report:', error);
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while fetching data', life: 3000 });
        });
    }

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData,
        }, () => {
            if (this.state.dropdownsData?.sectionIds) {
                this.applyAllFilters();

            }
        });
    }

    exportToExcel = () => {
        const { feeRefundReport, dropdownsData } = this.state;

        // Get complete filtered data without pagination
        let completeFilteredData = [...feeRefundReport];

        // Apply dropdown filters
        if (dropdownsData.sectionIds?.length) {
            completeFilteredData = completeFilteredData.filter(item =>
                dropdownsData.sectionIds.includes(item.sectionId[0])
            );
        }

        // Apply date range filter
        completeFilteredData = this.filterByDateRange(completeFilteredData);

        // Format data for export
        const exportData = completeFilteredData.map(item => ({
            'Student Id': item.enrollmentId,
            'Student Name': `${item.firstName} ${item.lastName}`,
            'Branch': item.branchName,
            'Board': item.boardName,
            'Class-Section': `${item.gradeName}-${item.sectionName}`,
            'Request From': item.adminUsername?.slice(3) || '',
            'Refund Date': item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : '-',
            'Refund Mode': item.refundMode || '-',
            'Transaction Id': item.transactionId || '-',
            'Fee Type': item.refundFeeTypesData?.feeType || '',
            'Refund Amount': item.refundFeeTypesData?.refundAmt ? (item.refundFeeTypesData?.refundAmt).toFixed(2) : '0',
            'Approved By': item.handledBy?.length > 0 ? item.handledBy[item.handledBy.length - 1]?.userName.slice(3) : '',
            'Approved Remarks': item.handledBy?.length > 0 ? item.handledBy[item.handledBy.length - 1]?.remarks : '',
            'Approved Date': item.handledBy?.length > 0 ? moment(item.handledBy[item.handledBy.length - 1]?.handledDate).format('DD/MM/YYYY') : '-'
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Refund Report");

        // Generate and download file
        XLSX.writeFile(workbook, `Refund_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
    }
    applyAllFilters = () => {
        const { feeRefundReport, dropdownsData, lazyParams } = this.state;
        let filtered = [...feeRefundReport];

        // Apply dropdown filters
        if (dropdownsData.sectionIds?.length) {
            filtered = filtered.filter(item =>
                dropdownsData.sectionIds.includes(item.sectionId[0])
            );
        }

        // Apply date range filter
        filtered = this.filterByDateRange(filtered);

        // Store total records count before pagination
        const totalFilteredRecords = filtered.length;

        // Apply pagination
        const first = lazyParams.first || 0;
        const rows = lazyParams.rows || 5; // Default to 5 per page
        const paginatedData = filtered.slice(first, first + rows);

        console.log('Pagination details:', {
            totalRecords: totalFilteredRecords,
            first,
            rows,
            paginatedDataLength: paginatedData.length,
            page: Math.floor(first / rows) + 1
        });

        this.setState({
            filteredData: paginatedData,
            totalRecords: totalFilteredRecords
        });
    }

    onPage = (event) => {
        console.log('Page event:', event); // For debugging pagination events
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    first: event.first,
                    rows: event.rows,
                    page: event.page || Math.floor(event.first / event.rows)
                }
            };
        }, () => {
            this.applyAllFilters();
        });
    }

    handleDateRangeChange = (selectedOption) => {
        console.log("Date range option selected:", selectedOption);

        // Reset date inputs when changing selection
        let newState = {
            selectedDateRange: selectedOption,
            showCustomDateRange: selectedOption === 8, // Show custom date inputs only if Custom option is selected
        };

        // Clear dates only if switching to a non-custom option or changing between options
        if (selectedOption !== 8) {
            newState.startDate = null;
            newState.endDate = null;
        }

        this.setState(newState, () => {
            this.applyAllFilters();
        });
    }


    render() {
        console.log("Current state:", {
            selectedDateRange: this.state.selectedDateRange,
            showCustomDateRange: this.state.showCustomDateRange,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        });

        return (
            <>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    padding: '0',
                    marginLeft: "100px",
                    marginTop: "60px",
                    overflow: 'auto',

                }}>
                    <div className="card filters-card mt-1 pt-0">
                        {/* First Row - Branch Section */}
                        <div className="flex mb-4">
                            <div className="col-12">
                                <BranchToSectionMultiDDTillSecReports setValues={this.setDropdownValues} />
                            </div>
                        </div>

                        {/* Second Row - Date Range and Buttons */}
                        <div className="grid ml-1">
                            {/* Date Range Dropdown */}
                            <div className="col-10">
                                <div className="grid">
                                    <div className="col-3">
                                        <ClassetDropdown
                                            label={'Date Range'}
                                            className="w-full"
                                            options={dateRangeOptions}
                                            value={this.state.selectedDateRange}
                                            optionValue='value'
                                            optionLabel='label'
                                            onChange={(e) => this.handleDateRangeChange(e.value)}
                                            placeholder={(
                                                <div>
                                                    <span className=''>Select Date Range</span>
                                                </div>
                                            )}
                                        />
                                    </div>

                                    {/* Show custom date inputs only when Custom option is selected */}
                                    {this.state.showCustomDateRange && (
                                        <div className='flex'>

                                            <div className="col-4">
                                                <ClassetCalendar
                                                    label={'From Date'}
                                                    className="w-full"
                                                    value={this.state.startDate}
                                                    onChange={(e) => {
                                                        console.log("Start date selected:", e.value);
                                                        this.setState({
                                                            startDate: e.value
                                                        }, () => {
                                                            this.applyAllFilters();
                                                        });
                                                    }}
                                                    calendarMode={'single'}
                                                    dateFormat="dd/mm/yy"
                                                    placeholder="Select From Date"
                                                />
                                            </div>
                                            <div className="col-4">
                                                <ClassetCalendar
                                                    label={'To Date'}
                                                    className="w-full"
                                                    value={this.state.endDate}
                                                    calendarMode={'single'}
                                                    onChange={(e) => {
                                                        console.log("End date selected:", e.value);
                                                        this.setState({
                                                            endDate: e.value
                                                        }, () => {
                                                            this.applyAllFilters();
                                                        });
                                                    }}
                                                    dateFormat="dd/mm/yy"
                                                    placeholder="Select To Date"
                                                    minDate={this.state.startDate}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="col-2 flex justify-content-end align-items-end " style={{ marginTop: "-10px" }}>
                                <div className="flex gap-3">
                                    <Button
                                        label="Download Report"
                                        onClick={this.exportToExcel}
                                        style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                    />
                                    <Button
                                        label="View Analysis"
                                        className="p-button-primary"
                                        style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='datatable-report-demo mx-2'>
                        <DataTable
                            value={this.state.filteredData}
                            dataKey="_id" // Using _id as the unique identifier
                            paginator
                            lazy
                            responsiveLayout="scroll"
                            columnResizeMode="expand"
                            resizableColumns
                            onPage={this.onPage}
                            first={this.state.lazyParams.first}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                            rowClassName={() => 'table-row-style'}
                            alwaysShowPaginator={true}
                        >

                            <Column field="" header="Student Id"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData.username?.slice(3)}
                                        </p>
                                    )
                                }}
                            />
                            <Column filterField="firstName" field="" header="Student Name"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.firstName} {rowData?.lastName}
                                        </p>
                                    )
                                }}
                            />

                            <Column filterField="branchName" field="username" header="Branch"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.branchName}
                                        </p>
                                    )
                                }} />
                            <Column filterField="boardName" header="Board"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.boardName}
                                        </p>
                                    )
                                }} />
                            <Column filterField="" field="" header="Class-Section"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.gradeName + "-" + rowData?.sectionName}
                                        </p>
                                    )
                                }} />
                            <Column filterField="" field="" header="Request From"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.adminUsername?.slice(3)}
                                        </p>
                                    )
                                }} />
                            <Column
                                header="Refund Date"

                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.createdAt ? moment(rowData.createdAt).format('DD/MM/YYYY') : '-'}
                                        </p>
                                    )
                                }}
                            />
                            <Column
                                header="Refund Mode"

                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.refundMode || '-'}
                                        </p>
                                    )
                                }}
                            />
                            <Column
                                header="Transaction Id"

                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.transactionId || '-'}
                                        </p>
                                    )
                                }}
                            />
                            <Column field="" header="Fee Type"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.refundFeeTypesData?.feeType}
                                        </p>
                                    )
                                }}
                            />
                            <Column field="" header="Refund Amount"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.refundFeeTypesData?.refundAmt ? (rowData?.refundFeeTypesData?.refundAmt).toFixed(2) : 0}
                                        </p>
                                    )
                                }}
                            />
                            <Column filterField="approvedBy" field="" header="Approved By"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.handledBy?.length > 0 ? rowData.handledBy[rowData.handledBy.length - 1]?.userName.slice(3) : ''}
                                        </p>
                                    )
                                }} />
                            <Column filterField="approvedRemarks" field="" header="Approved Remarks"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.handledBy?.length > 0 ? rowData.handledBy[rowData.handledBy.length - 1]?.remarks : ''}
                                        </p>
                                    )
                                }} />
                            <Column filterField="" field="approvedDate" header="Approved Date"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>

                                            {rowData?.handledBy?.length > 0 ? moment(rowData.handledBy[rowData.handledBy.length - 1]?.handledDate).format('DD/MM/YYYY') : '-'}
                                        </p>
                                    )
                                }} />


                        </DataTable>
                    </div>

                </div>
                {this.state.isLoading && <LoadingComponent />}
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>
        )
    }
}
const mapStateToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStateToProps, {
    getBranchesLatest
})(Authentication(withRouter(RefundReport)));

